var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetPreview = function SvgAssetPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.499 2.868a11.7 11.7 0 0 0-3.5-.534c-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666 6.443 0 11.666-5.223 11.666-11.666 0-1.22-.187-2.395-.534-3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.5 11.666a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M6.418 22.75l.654-1.145a5.83 5.83 0 0 1 5.065-2.939h3.73a5.83 5.83 0 0 1 5.064 2.94l.654 1.143M22.137 2.359c.007-.033.055-.033.062 0a4.42 4.42 0 0 0 3.444 3.444c.033.007.033.055 0 .062a4.42 4.42 0 0 0-3.444 3.444c-.007.033-.055.033-.062 0a4.42 4.42 0 0 0-3.444-3.444c-.033-.007-.033-.055 0-.062a4.42 4.42 0 0 0 3.444-3.444"
  })));
};
export default SvgAssetPreview;